import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
/**
 * Minimal Facebook Pixel hook - only tracks PageView events on route changes
 * No conversions, no fallbacks, no image beacons
 */
export const useFacebookPixel = () => {
  const location = useLocation();
  useEffect(() => {
    const fbq = window.fbq as undefined | ((...a: any[]) => void);
    if (!fbq) return;
    // SPA pageview only
    fbq('track', 'PageView');
    // Simple custom events for page views (no conversions)
    if (location.pathname === '/') {
      fbq('trackCustom', 'offerte_pageview', {
        page_path: location.pathname,
        t: Date.now()
      });
    } else if (location.pathname === '/bedankt') {
      fbq('trackCustom', 'bedankt_pageview', {
        page_path: location.pathname,
        t: Date.now()
      });
    }
  }, [location.pathname]);
};
export default useFacebookPixel;